import API_BASE_URL, { API_ENDPOINTS } from "../config/api";
import { supabase } from "../auth/supabase";

const wishlistRoute = async () => {
  const { data } = await supabase.auth.getSession();
  return data.session?.user?.is_anonymous
    ? `${API_BASE_URL}/api/guest/wishlist`
    : API_ENDPOINTS.WISHLIST.ROUTE;
};

//get wishlist items
export const getWishlistItems = async (
  page = 1,
  perPage = 20,
  view = "card"
) => {
  try {
    const url = `${await wishlistRoute()}?page=${page}&per_page=${perPage}&view=${view}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Wishlist items not found");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Wishlist Fetch Error:", error);
    return { success: false, error: error.message };
  }
};

//add item in wishlist
export const addWishlistItem = async (item_id, notes = "") => {
  try {
    const response = await fetch(await wishlistRoute(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ item_id: String(item_id), notes }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Failed to add item to wishlist");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Wishlist Add Error:", error);
    return { success: false, error: error.message };
  }
};

//remove wishlist item
export const deleteWishlistItem = async (item_id, mode = "item") => {
  try {
    const response = await fetch(
      `${await wishlistRoute()}/${item_id}?source=${mode}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ item_id, mode }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Failed to remove item to wishlist");
    }

    return { success: true, data };
  } catch (error) {
    console.error("Wishlist item Deletion Error:", error);
    return { success: false, error: error.message };
  }
};
